export const formatNumber = (number) => {
  return isNaN(number)? number : new Intl.NumberFormat("en-US").format(number);
};
